import { jsx as l } from "react/jsx-runtime";
const a = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.755 2.7a3.093 3.093 0 0 1 3.043 2.542 3.093 3.093 0 0 1-2.047 5.785V14.5h-1.5v-2.877a3.093 3.093 0 0 1-2.565-5.456A3.093 3.093 0 0 1 9.755 2.7Zm1.218 6.836A1.595 1.595 0 0 0 13 8.003c0-.604-.336-1.149-.877-1.422l-.669-.337-.133-.737A1.589 1.589 0 0 0 9.755 4.2a1.595 1.595 0 0 0-1.58 1.787l.1.838-.664.522A1.585 1.585 0 0 0 7 8.599a1.595 1.595 0 0 0 2.25 1.453V7.89l1.5-.402v1.984l.223.063Zm-6.264.422.218-.18a3.71 3.71 0 0 0 1.472 1.945v2.788h-1.5v-2.96a2.543 2.543 0 0 1-2.424-4.397 2.543 2.543 0 0 1 3.662-2.582 3.689 3.689 0 0 0-.225 1.19l-.003.196-.135.14a.922.922 0 0 0-.011.012l-.011.012a1.043 1.043 0 0 0-1.788.851l.101.838-.664.521a1.045 1.045 0 1 0 1.308 1.626Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  a as Trees
};
